import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import './_styles_/ClientApplicationsTable.css';
import { clientApplicationsType } from '../../types';
import ClientApplicationsTableRow from './ClientApplicationsTableRow';
import { idSortFunc } from '../../utils/tableRecords';

ClientApplicationsTable.propTypes = {
    clientApplications: clientApplicationsType.isRequired,
    onClientApplicationDelete: PropTypes.func.isRequired,
    onClientApplicationValidated: PropTypes.func.isRequired,
    backendChanged: PropTypes.bool.isRequired,
    doReset: PropTypes.bool.isRequired,
};

function ClientApplicationsTable(props) {
    const {
        clientApplications,
        onClientApplicationDelete,
        onClientApplicationValidated,
        backendChanged,
        doReset,
    } = props;
    const { t } = useTranslation();
    const sortedClientApplications = [...clientApplications].sort(idSortFunc);
    return (
        <div className="detail-list">
            <div className="detail-list-row detail-list-header">
                <div className="client-application-cell--small">&nbsp;</div>
                <div className="client-application-cell client-applications-table-row--header--id">{t('settings.client-applications.table.id')}</div>
                <div className="client-application-cell client-applications-table-row--header--application-id">{t('settings.client-applications.table.application-id')}</div>
                <div className="client-application-cell client-applications-table-row--header--description">{t('settings.client-applications.table.description')}</div>
                <div className="client-application-cell client-applications-table-row--header--active">{t('settings.client-applications.table.active')}</div>
            </div>
            {sortedClientApplications.map((clientApplication) => (
                <ClientApplicationsTableRow
                    key={clientApplication.id}
                    clientApplication={clientApplication}
                    clientApplications={clientApplications}
                    onClientApplicationDelete={onClientApplicationDelete}
                    onClientApplicationValidated={onClientApplicationValidated(clientApplication)}
                    backendChanged={backendChanged}
                    doReset={doReset}
                />
            ))}
        </div>
    );
}

export default ClientApplicationsTable;
